import { Box, Container } from '@mui/material';

import { Skeleton } from '@/components';
import { EpisodeGrid } from '@/containers';

const LINE_HEIGHT = 22;

export const LearningPathSkeleton = () => {
  return (
    <Container>
      <Box sx={{ display: 'flex', gap: 2 }}>
        <Box
          sx={{
            display: {
              xs: 'none',
              sm: 'flex',
            },
            flexDirection: 'column',
            flexGrow: 1,
            justifyContent: 'center',
          }}>
          <Skeleton variant="text" height={LINE_HEIGHT} />
          <Skeleton variant="text" height={LINE_HEIGHT} />
          <Skeleton variant="text" height={LINE_HEIGHT} />
          <Skeleton variant="text" height={LINE_HEIGHT} width="60%" />
        </Box>
        <Skeleton
          variant="circular"
          height={200}
          width={200}
          sx={{ flexShrink: 0, mx: 'auto' }}
        />
      </Box>
      <Box mt={2}>
        <Skeleton height={LINE_HEIGHT} />
        <Skeleton height={LINE_HEIGHT} />
        <Skeleton height={LINE_HEIGHT} />
      </Box>
      <Box mt={2}>
        <EpisodeGrid isLoading />
      </Box>
    </Container>
  );
};
